module.exports = __webpack_public_path__ + "img/fte.5bd615d8.svg";